import { createRelativeResolvedModelPath, RelativeResolvedModelPath } from "./ModelPath/ModelPath";

export const UnitLabelPath: RelativeResolvedModelPath = createRelativeResolvedModelPath("label");

export const AttachmentInfoPath: RelativeResolvedModelPath = createRelativeResolvedModelPath("attachment");
export const UnitItemExtraInfoPath: RelativeResolvedModelPath = createRelativeResolvedModelPath("unitextrainfo");

export const TruthyTechnicalFieldValue: string = "1";
export const FalsyTechnicalFieldValue: null = null;

export const OptionalSectionFilledFieldName: string = "isFilledOptional";
export const OptionalElementsExistenceFieldName: string = "isExists";
export const OptionalBlockVisibilityFieldName: string = "isOptionalBlockVisible";

export const reservedForTechnicalUsageFields = [
    OptionalSectionFilledFieldName,
    OptionalElementsExistenceFieldName,
    OptionalBlockVisibilityFieldName,
];
